import React from 'react';
import PropTypes from 'prop-types';
import Team from './Team';
var Division = function Division(_ref) {
  var division = _ref.division,
    navPosition = _ref.navPosition;
  var _division$name = division.name,
    name = _division$name === void 0 ? '' : _division$name;
  // divisionSlug is for aria-labelledby
  var divisionSlug = name.replace(' ', '-').toLowerCase();
  var teams = division.teams.map(function (team) {
    return /*#__PURE__*/React.createElement(Team, {
      key: "".concat(team.name),
      team: team,
      navPosition: navPosition
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "header__subnav__group-title",
    id: divisionSlug
  }, name), /*#__PURE__*/React.createElement("ul", {
    className: "header__subnav--teams__teams",
    "aria-labelledby": divisionSlug
  }, teams));
};
export default Division;
Division.propTypes = {
  division: PropTypes.shape({
    divisionSlug: PropTypes.string,
    name: PropTypes.string,
    teams: PropTypes.array
  }).isRequired,
  navPosition: PropTypes.string
};